import TableWithShowInfoColumn from "../../../Components/NewTable/TableWithShowInfoColumn";
import ListContainer from "../../../Components/UI/ListContainer/ListContainer";
import useHttpFetch from "../../../hooks/useHttpFetch";
import useListStateCustom from "../../../hooks/useListStateCustom";
import MultiLanTxt from "../../../Components/UI/MultiLanTxt/MultiLanTxt";
import { useNavigate } from "react-router-dom";
import classes from "./List.module.css";

const pageHeader = "StepStairCommission List";
const routeEntity = "step-stair-commission";

const initialTableInfos = [
  {
    id: "sa121011l5",
    uniqueName: "StepStairCommission_id",
    label: "شناسه",
    show: false,
    order: 1,
    field: "id",
    neededAccesses: ["StepStairCommission_id"],
  },
  {
    id: "sapo11fisca4",
    uniqueName: "StepStairCommission_name",
    label: <MultiLanTxt tid="name" />,
    show: true,
    order: 2,
    field: "name",
    neededAccesses: ["StepStairCommission_name"],
  },
  {
    id: "sapop1fisca4",
    uniqueName: "StepStairCommission_code",
    label: <MultiLanTxt tid="code" />,
    show: true,
    order: 3,
    field: "code",
    neededAccesses: ["StepStairCommission_code"],
  },
  {
    id: "sapop1f2sca4",
    uniqueName: "StepStairCommission_directSale",
    label: <MultiLanTxt tid="directSale" />,
    show: true,
    order: 4,
    field: "directSale",
    neededAccesses: ["StepStairCommission_directSale"],
  },
  {
    id: "sapop1a25ca4",
    uniqueName: "StepStairCommission_superiorName",
    label: <MultiLanTxt tid="superiorName" />,
    show: true,
    order: 5,
    field: "superiorName",
    neededAccesses: ["StepStairCommission_superiorName"],
  },
  {
    id: "sapop1f25ca4",
    uniqueName: "StepStairCommission_superiorCode",
    label: <MultiLanTxt tid="superiorCode" />,
    show: true,
    order: 6,
    field: "superiorCode",
    neededAccesses: ["StepStairCommission_superiorCode"],
  },
  {
    id: "sapop88aaa4",
    uniqueName: "StepStairCommission_rankLevel",
    label: <MultiLanTxt tid="rankLevel" />,
    show: true,
    order: 7,
    field: "stepStairCommission.rankLevel",
    neededAccesses: ["StepStairCommission_stepStairCommission", "StepStairCommission_rankLevel"],
  },
  {
    id: "sapop88a114",
    uniqueName: "StepStairCommission_networkMarketerdirectSaleScore",
    label: <MultiLanTxt tid="networkMarketerdirectSaleScore" />,
    show: true,
    order: 8,
    field: "stepStairCommission.networkMarketerdirectSaleScore",
    neededAccesses: [
      "StepStairCommission_stepStairCommission",
      "StepStairCommission_networkMarketerdirectSaleScore",
    ],
  },
  {
    id: "sap111aaa4",
    uniqueName: "StepStairCommission_stepStairCommission",
    label: <MultiLanTxt tid="stepStairCommission" />,
    show: true,
    order: 9,
    field: "stepStairCommission.stepStairCommission",
    neededAccesses: [
      "StepStairCommission_stepStairCommission",
      "StepStairCommission_stepStairCommission",
    ],
  },
  {
    id: "sapop88asa4",
    uniqueName: "StepStairCommission_totalPersonalGroupScore",
    label: <MultiLanTxt tid="totalPersonalGroupScore" />,
    show: true,
    order: 10,
    field: "stepStairCommission.totalPersonalGroupScore",
    neededAccesses: [
      "StepStairCommission_stepStairCommission",
      "StepStairCommission_totalPersonalGroupScore",
    ],
  },
  {
    id: "sapop88aary",
    uniqueName: "StepStairCommission_totalGenerationCommission",
    label: <MultiLanTxt tid="totalGenerationCommission" />,
    show: true,
    order: 11,
    field: "stepStairCommission.totalGenerationCommission",
    neededAccesses: [
      "StepStairCommission_stepStairCommission",
      "StepStairCommission_totalGenerationCommission",
    ],
  },
  {
    id: "sapop8830a4",
    uniqueName: "StepStairCommission_totalScoreOfNetworkMarketer",
    label: <MultiLanTxt tid="totalScoreOfNetworkMarketer" />,
    show: true,
    order: 12,
    field: "stepStairCommission.totalScoreOfNetworkMarketer",
    neededAccesses: [
      "StepStairCommission_stepStairCommission",
      "StepStairCommission_totalScoreOfNetworkMarketer",
    ],
  },
  {
    id: "sap338aaa4",
    uniqueName: "StepStairCommission_numberOfDirects",
    label: <MultiLanTxt tid="numberOfDirects" />,
    show: true,
    order: 13,
    field: "stepStairCommission.numberOfDirects",
    neededAccesses: ["StepStairCommission_stepStairCommission", "StepStairCommission_numberOfDirects"],
  },
  {
    id: "sapop88aab4",
    uniqueName: "StepStairCommission_totalNumberOfTeam",
    label: <MultiLanTxt tid="totalNumberOfTeam" />,
    show: true,
    order: 14,
    field: "stepStairCommission.totalNumberOfTeam",
    neededAccesses: ["StepStairCommission_stepStairCommission", "StepStairCommission_totalNumberOfTeam"],
  },
  {
    id: "sapopaa114",
    uniqueName: "StepStairCommission_fromDate",
    label: <MultiLanTxt tid="fromDate" />,
    show: true,
    order: 15,
    type: "date",
    attachTime: true,
    field: "stepStairCommission.fromDate",
    neededAccesses: ["StepStairCommission_stepStairCommission", "StepStairCommission_fromDate"],
  },
  {
    id: "sapoqaa114",
    uniqueName: "StepStairCommission_toDate",
    label: <MultiLanTxt tid="toDate" />,
    show: true,
    order: 16,
    type: "date",
    attachTime: true,
    field: "stepStairCommission.toDate",
    neededAccesses: ["StepStairCommission_stepStairCommission", "StepStairCommission_toDate"],
  },
  {
    id: "safop1a114",
    uniqueName: "StepStairCommission_generationCommissionVersion",
    label: <MultiLanTxt tid="generationCommissionVersion" />,
    show: true,
    order: 17,
    field: "stepStairCommission.generationCommissionVersion",
    neededAccesses: [
      "StepStairCommission_stepStairCommission",
      "StepStairCommission_generationCommissionVersion",
    ],
  },
  {
    id: "sapop88a004",
    uniqueName: "StepStairCommission_totalChildrenSaleScoreOf1stGeneration",
    label: <MultiLanTxt tid="totalChildrenSaleScoreOf1stGeneration" />,
    show: true,
    order: 18,
    field: "stepStairCommission.totalChildrenSaleScoreOf1stGeneration",
    neededAccesses: [
      "StepStairCommission_stepStairCommission",
      "StepStairCommission_totalChildrenSaleScoreOf1stGeneration",
    ],
  },
  {
    id: "sapop88aa04",
    uniqueName: "StepStairCommission_totalChildrenSaleScoreOf2ndGeneration",
    label: <MultiLanTxt tid="totalChildrenSaleScoreOf2ndGeneration" />,
    show: true,
    order: 19,
    field: "stepStairCommission.totalChildrenSaleScoreOf2ndGeneration",
    neededAccesses: [
      "StepStairCommission_stepStairCommission",
      "StepStairCommission_totalChildrenSaleScoreOf2ndGeneration",
    ],
  },
  {
    id: "sap2536a4",
    uniqueName: "StepStairCommission_totalChildrenSaleScoreOf3rdGeneration",
    label: <MultiLanTxt tid="totalChildrenSaleScoreOf3rdGeneration" />,
    show: true,
    order: 20,
    field: "stepStairCommission.totalChildrenSaleScoreOf3rdGeneration",
    neededAccesses: [
      "StepStairCommission_stepStairCommission",
      "StepStairCommission_totalChildrenSaleScoreOf3rdGeneration",
    ],
  },
  {
    id: "fvsd5565gv",
    uniqueName: "StepStairCommission_totalChildrenSaleScoreOf4thGeneration",
    label: <MultiLanTxt tid="totalChildrenSaleScoreOf4thGeneration" />,
    show: true,
    order: 21,
    field: "stepStairCommission.totalChildrenSaleScoreOf4thGeneration",
    neededAccesses: [
      "StepStairCommission_stepStairCommission",
      "StepStairCommission_totalChildrenSaleScoreOf4thGeneration",
    ],
  },
  {
    id: "sapopsssa4",
    uniqueName: "StepStairCommission_totalChildrenSaleScoreOf5thGeneration",
    label: <MultiLanTxt tid="totalChildrenSaleScoreOf5thGeneration" />,
    show: true,
    order: 22,
    field: "stepStairCommission.totalChildrenSaleScoreOf5thGeneration",
    neededAccesses: [
      "StepStairCommission_stepStairCommission",
      "StepStairCommission_totalChildrenSaleScoreOf5thGeneration",
    ],
  },
  {
    id: "545ghgbbbbdx",
    uniqueName: "StepStairCommission_totalChildrenSaleScoreOf6thGeneration",
    label: <MultiLanTxt tid="totalChildrenSaleScoreOf6thGeneration" />,
    show: true,
    order: 22,
    field: "stepStairCommission.totalChildrenSaleScoreOf6thGeneration",
    neededAccesses: [
      "StepStairCommission_stepStairCommission",
      "StepStairCommission_totalChildrenSaleScoreOf6thGeneration",
    ],
  },
  {
    id: "sfgvdfgvdfg",
    uniqueName: "StepStairCommission_totalChildrenSaleScoreOf7thGeneration",
    label: <MultiLanTxt tid="totalChildrenSaleScoreOf7thGeneration" />,
    show: true,
    order: 23,
    field: "stepStairCommission.totalChildrenSaleScoreOf7thGeneration",
    neededAccesses: [
      "StepStairCommission_stepStairCommission",
      "StepStairCommission_totalChildrenSaleScoreOf7thGeneration",
    ],
  },
  {
    id: "r5sssdcds",
    uniqueName: "StepStairCommission_totalChildrenSaleScoreOf8thGeneration",
    label: <MultiLanTxt tid="totalChildrenSaleScoreOf8thGeneration" />,
    show: true,
    order: 24,
    field: "stepStairCommission.totalChildrenSaleScoreOf8thGeneration",
    neededAccesses: [
      "StepStairCommission_stepStairCommission",
      "StepStairCommission_totalChildrenSaleScoreOf8thGeneration",
    ],
  },
  {
    id: "saprydd8aaa4",
    uniqueName: "StepStairCommission_totalChildrenSaleScoreOf9thGeneration",
    label: <MultiLanTxt tid="totalChildrenSaleScoreOf9thGeneration" />,
    show: true,
    order: 25,
    field: "stepStairCommission.totalChildrenSaleScoreOf9thGeneration",
    neededAccesses: [
      "StepStairCommission_stepStairCommission",
      "StepStairCommission_totalChildrenSaleScoreOf9thGeneration",
    ],
  },
  {
    id: "saryd8aaa4",
    uniqueName: "StepStairCommission_totalChildrenSaleScoreOf10thGeneration",
    label: <MultiLanTxt tid="totalChildrenSaleScoreOf10thGeneration" />,
    show: true,
    order: 26,
    field: "stepStairCommission.totalChildrenSaleScoreOf10thGeneration",
    neededAccesses: [
      "StepStairCommission_stepStairCommission",
      "StepStairCommission_totalChildrenSaleScoreOf10thGeneration",
    ],
  },
];

const FormNetworkMarketerList = () => {
  const { isLoading, sendRequest } = useHttpFetch(false, "FNM");
  const navigate = useNavigate();
  const {
    datas,
    tableInfos,
    setTableInfos,
    clonedTableInfos,
    totalRecords,
    fieldAccessesAreLoading,
    actionStatus,
    setActionStatus,
    actionHandler,
    sendReqPerChange,
    enumOptions,
  } = useListStateCustom({
    usedListEntities: ["StepStairCommission"],
    initialTableInfos,
    urlMainEntity: "getStepStairCommission",
    routeEntity,
    sendRequest,
    customSearchStrInUrl: "mlmDataEntry",
    port: "9092",
  });

  return (
    <>
      <ListContainer>
        <TableWithShowInfoColumn
          datas={datas}
          editablelity={false}
          sendReqPerChange={sendReqPerChange}
          totalRecords={totalRecords}
          selectable={false}
          isLoading={isLoading}
          actionHandler={actionHandler}
          actionStatus={actionStatus}
          setActionStatus={setActionStatus}
          tableInfos={tableInfos}
          setTableInfos={setTableInfos}
          clonedTableInfos={clonedTableInfos}
          canAdd={false}
          canEdit={false}
          canDelete={false}
          fieldAccessesAreLoading={fieldAccessesAreLoading}
          enumOptions={enumOptions}
          pageHeader={pageHeader}
          customWidth={200}
        />
      </ListContainer>
      <span
        className={classes.addTableFeatureContainer}
        onClick={() => navigate("/form-network-marketer")}
      >
        network marketer
      </span>
    </>
  );
};

export default FormNetworkMarketerList;
